export default __webpack_public_path__ + "img/feed.9e996f7d.png";